<template>
  <ym-playing-btn class="header-playing-btn"
                  :show="show"
                  :status="floatBtnStatus"
                  @click="handleClickFloatBtn"
  />
</template>

<script>
  import { mapGetters } from 'vuex';
  import PlayingBtn from '@/components/AudioPlayingBtn';

  export default {
    name: 'YmMiniPlayer',
    components: {
      'ym-playing-btn': PlayingBtn,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      playingId() {
        return this.player.playingId;
      },
      playing() {
        return this.playingId > 0;
      },
      loading() {
        return this.player.loadingStatus === 'loading';
      },
      floatBtnStatus() {
        const { playing, loading } = this;
        return !loading && playing ? 'playing' : 'normal';
      },
    },
    methods: {
      handleClickFloatBtn() {
        this.$emit('mini-player-click');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .header-playing-btn {
    flex-shrink: 0;
    margin-left: @size-base;
  }
</style>
